import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('fcFwdCkuTestStore', Object.keys(getters)),
	...mapState('fcFwdCkuTestStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('fcFwdCkuTestStore', Object.keys(actions)),
	...mapMutations('fcFwdCkuTestStore', Object.keys(mutations))
};
